import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Constants } from '../constants';
import { DateUtil } from '../utils/date.util';

@Pipe({
  name: 'localeDateFormat'
})
export class LocaleDateFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return DateUtil.getLocalDateFormat(value);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/locale-date-format.pipe.ts